export const TelkomIdCreds = {
  nik: 202212345,
  password: "legionadmin"
}

export const UsernameCreds = {
  fullName: "Legion Telkom Design",
  username: "legiontedis",
  email: "legion@telkom.design",
  password: "legionAdmin27",
}